/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type SupportAPIResponse = {
  __typename: "SupportAPIResponse",
  message?: string | null,
  success?: boolean | null,
};

export type Shipment = {
  shipmentId?: string | null,
  containerNumber?: string | null,
  billOfLading?: string | null,
};

export type ManualTantCorrectionResponse = {
  __typename: "ManualTantCorrectionResponse",
  status?: Status | null,
  error?: Error | null,
};

export enum Status {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}


export type Error = {
  __typename: "Error",
  message?: string | null,
};

export type DivertFromUkUploadUrlResponse = {
  __typename: "DivertFromUkUploadUrlResponse",
  uploadUrl: string,
  fileId: string,
};

export type TantEvent = {
  __typename: "TantEvent",
  id: string,
};

export type SubmitTantEventMutationVariables = {
  rawEvent: string,
};

export type SubmitTantEventMutation = {
  submitTantEvent?:  {
    __typename: "SupportAPIResponse",
    message?: string | null,
    success?: boolean | null,
  } | null,
};

export type SubmitManualTantCorrectionMutationVariables = {
  location?: string | null,
  shipments?: Array< Shipment | null > | null,
  reason?: string | null,
  comment?: string | null,
};

export type SubmitManualTantCorrectionMutation = {
  submitManualTantCorrection?:  {
    __typename: "ManualTantCorrectionResponse",
    status?: Status | null,
    error?:  {
      __typename: "Error",
      message?: string | null,
    } | null,
  } | null,
};

export type RequestDivertFromUkUploadUrlMutationVariables = {
};

export type RequestDivertFromUkUploadUrlMutation = {
  requestDivertFromUkUploadUrl:  {
    __typename: "DivertFromUkUploadUrlResponse",
    uploadUrl: string,
    fileId: string,
  },
};

export type TriggerProcessDivertFromUkFileMutationVariables = {
  fileId: string,
};

export type TriggerProcessDivertFromUkFileMutation = {
  triggerProcessDivertFromUkFile:  {
    __typename: "SupportAPIResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type AllTantEventQueryVariables = {
};

export type AllTantEventQuery = {
  allTantEvent?:  Array< {
    __typename: "TantEvent",
    id: string,
  } | null > | null,
};
